import { ReferralProgram, ReferralProgramResponse } from 'modules/strapi/types';

export const mapReferralProgramResponseToReferralProgram = ({
  benefits,
  blockchains,
  bundleID,
  cover,
  name,
  referralCode,
  stageOnly,
  welcomeDialogDescription,
  welcomeDialogTitle,
}: ReferralProgramResponse): ReferralProgram => ({
  benefits,
  blockchains,
  bundleID,
  cover: cover?.url
    ? new URL(cover.url, import.meta.env.VITE_STRAPI_URL).toString()
    : undefined,
  name,
  referralCode,
  stageOnly,
  welcomeDialogDescription,
  welcomeDialogTitle,
});
